import * as React from 'react';
import { Button } from 'react-bootstrap';

export interface ILoginAadButtonProps {
  buttonText: string;
  className: string;
}

export default class LoginAadButton extends React.Component<
  ILoginAadButtonProps
> {
  public render() {
    return (
      <Button
        onClick={() => {
          sessionStorage.setItem('signedOut', 'false');
          sessionStorage.setItem('isUsingAAD', 'true');
          window.location.assign(window.location.origin + '/LoginAAD');
        }}
        className={this.props.className}
      >
        {this.props.buttonText}
      </Button>
    );
  }
}
